import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom



const Support = () => {


    const navigate = useNavigate();

    return (
        <div className='RightSideDiv'>
        <div class="right-top">
            <input type="text" class="search-input" placeholder="Search . . ." />
            <button><img src={window.getPublicUrl('/assets/images/plus.svg')} alt="" /> Add</button>
        </div>
        <div class="table-outer">
            <table class="table">
                <thead>
                    <tr class="t-heading">

                        <th class="date">
                            <h5>Id</h5>
                        </th>
                        <th class="order">
                            <h5>User Info</h5>
                        </th>
                        <th class="info">
                            <h5>Account Type</h5>
                        </th>
                        <th class="refrence">
                            <h5>Date Created</h5>
                        </th>
                        <th class="total-amount">
                            <h5>Last Login</h5>
                        </th>
                        <th class="order-status">
                            <h5>Action</h5>
                        </th>

                    </tr>
                </thead>
                <tbody>

                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>
                    <tr class="green">
                        <td class="date">
                            <h5>#1
                            </h5>
                        </td>
                        <td class="order">
                            <span class="user-img"></span>
                            <td class="info">
                                <h5>Closer Expert</h5>
                            </td>
                        </td>
                        <td class="info">
                            <h5>Closer Expert</h5>
                        </td>
                        <td class="refrence">
                            <h5>2023-06-15</h5>
                        </td>
                        <td class="total-amount">
                            <h5>2024-10-25</h5>
                        </td>

                        <td class="action">
                            <td class="action">
                                <button><img src="/willow//assets/images/view.svg" alt="" /></button>
                                <button className='edit'><img src="/willow//assets/images/edit.svg" alt="" /></button>
                                <button ><img src="/willow//assets/images/delete.svg" alt="" /></button>
                            </td>
                        </td>
                    </tr>



                </tbody>
            </table>
        </div>
    </div>
    );
}

export default Support;